import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State, userFeatureKey } from '../reducers/user.reducer';

export const selectUserFeature = createFeatureSelector<State>(userFeatureKey);

export const selectLoaded = createSelector(selectUserFeature, (state: State) => state.loaded);

export const selectDetails = createSelector(selectUserFeature, (state: State) => ({
  company: state.company,
  email: state.email,
  firstName: state.firstName,
  lastName: state.lastName,
  phone: state.phone
}));

export const selectId = createSelector(selectUserFeature, (state: State) => state.id);

export const selectEmail = createSelector(selectUserFeature, (state: State) => state.email);

export const selectFarmAlertsConfiguration = createSelector(selectUserFeature, (state: State) => ({
  farmAlertsEmailNotifications: state.farmAlertsEmailNotifications,
  farmAlertsPushNotifications: state.farmAlertsPushNotifications,
  subscribeToFarmAlerts: state.subscribeToFarmAlerts
}));
